import { RefObject, useEffect, useState } from 'react'

const BODY_SELECTOR = '.virtualized-body-wrapper'
const ROW_SELECTOR = '[data-index]'

const useVirtualizedRowsHeight = <T extends HTMLElement>(
    wrapperRef: RefObject<T | null>,
    maxRows: number,
    initial: number
): number => {
    const [height, setHeight] = useState(initial)

    useEffect(() => {
        const body = wrapperRef.current?.querySelector<HTMLElement>(BODY_SELECTOR)
        if (!body || typeof ResizeObserver === 'undefined') return

        const observer = new ResizeObserver(() => {
            const total = Array.from(
                body.querySelectorAll<HTMLElement>(ROW_SELECTOR)
            )
                .map((el) => [Number(el.dataset.index), el.offsetHeight] as const)
                .sort(([a], [b]) => a - b)
                .slice(0, maxRows)
                .reduce((sum, [, h]) => sum + h, 0)
            if (total > 0) setHeight(total)
        })
        observer.observe(body)
        return () => observer.disconnect()
    }, [wrapperRef, maxRows])

    return height
}

export default useVirtualizedRowsHeight
